import React from 'react';
import { connect } from 'react-redux';

import { Dispatch, RootState } from '../../store/store';

// Components
import ProfileInfoForm from '../../components/ProfileInfoForm/ProfileInfoForm';
import ProfileEmailForm from '../../components/ProfileEmailForm/ProfileEmailForm';
import SpinnerLoader from '../../components/SpinnerLoader/SpinnerLoader';
import ProfilePasswordForm from '../../components/ProfilePasswordForm/ProfilePasswordForm';

type ProfileProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;

const Profile: React.FC<ProfileProps> = ({ currentUser, updateUserInfo, changeEmail, verifyEmail, changePassword }) => {

  return (
    <>
      <div className="p-profile pb-4 md:pb-25">
        <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
          <div className="border-b border-stroke py-4 px-7 dark:border-strokedark">
            <h3 className="font-medium text-black dark:text-white">
              Personal Information
            </h3>
          </div>
          {currentUser !== null ? (
            <div className="p-7 flex flex-col gap-y-6">
              <ProfileInfoForm
                defaultFormData={{
                  first_name: currentUser.first_name,
                  last_name: currentUser.last_name,
                }}
                onSubmit={updateUserInfo}
              />
              <ProfileEmailForm email={currentUser.email} changeEmail={changeEmail} verifyEmail={verifyEmail} />
              <ProfilePasswordForm changePassword={changePassword} />
            </div>
          ) : (
            <div className='min-h-100 w-full flex justify-center items-center'>
              <SpinnerLoader />
            </div>

          )}
        </div>
      </div>
    </>
  );
};

const mapState = (state: RootState) => ({
  currentUser: state.user.profile,
});

const mapDispatch = (dispatch: Dispatch) => ({
  updateUserInfo: dispatch.user.updateUserInfo,
  changeEmail: dispatch.user.changeEmail,
  verifyEmail: dispatch.user.verifyEmail,
  changePassword: dispatch.user.changePassword,
});

export default connect(mapState, mapDispatch)(Profile);
